/**
 * Fixed paper-grain overlay — a tiny inline SVG feTurbulence tile, multiplied
 * over the warm canvas at ~4% opacity. Purely decorative, never interactive.
 */

const GRAIN =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.82' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23g)'/%3E%3C/svg%3E"

export function GrainOverlay() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-[60] opacity-[0.045] mix-blend-multiply"
      style={{ backgroundImage: `url("${GRAIN}")`, backgroundSize: '140px 140px' }}
    />
  )
}
